import React, { useEffect } from "react";
import { Chart } from "chart.js/auto";

const CustomChart = (props) => {
  useEffect(() => {
    const data = props.data;
    const ctx = document.getElementById(props.id).getContext("2d");

    // if (props.borderColor) {
    // }
    // if (props.id === "NewCustomers2") {
    //   data["datasets"][0]["borderColor"] = props.borderColor;
    //   console.log("asd", data);
    // }
    const chrt = new Chart(ctx, {
      type: props.type,
      data: data,
      options: props.options,
    });

    return () => {
      chrt.destroy();
    };
  }, [props.data, props.id, props.options, props.type]);
  return (
    <canvas id={props.id} width={props.width} height={props.height}></canvas>
  );
};

export default CustomChart;
